import {ReviewsCountByAspectsType} from '../../../../../service/reivew-analysis/review-aspects/review-aspects-type';
import {getAspectStrength} from '../keywords-and-topics-page/aspects-tab/aspects-helper';
import {AspectStrengthEnum} from '../keywords-and-topics-page/aspects-tab/aspects-tab-type';

// BST-10541 single-location page: classify the company's aspects into strong /
// weak sides via the Step-1 tonality thresholds and return names.
export function getStrongWeakAspectsFromReviews(
    reviewsByAspects: ReviewsCountByAspectsType['reviewsByAspects'],
    strength: AspectStrengthEnum
): Array<string> {
    return reviewsByAspects
        .filter((aspect) => getAspectStrength(aspect.currentPeriodData.tonalityIdx) === strength)
        .map((aspect) => aspect.aspect);
}
